import { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";

const emptyForm = {
  name: "",
  code: "",
  symbol: "",
  decimalPlaces: 0,
  isActive: true,
};

export default function UnitModal({
  open,
  onClose,
  onSave,
  initialData = null,
}) {
  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    if (!open) return;

    setForm(
      initialData
        ? {
            name: initialData.name || "",
            code: initialData.code || "",
            symbol: initialData.symbol || "",
            decimalPlaces: initialData.decimalPlaces ?? 0,
            isActive: initialData.isActive ?? true,
          }
        : emptyForm,
    );
  }, [open, initialData]);

  if (!open) return null;

  const handleSubmit = (event) => {
    event.preventDefault();

    onSave({
      name: form.name.trim(),
      code: form.code.trim().toUpperCase(),
      symbol: form.symbol.trim(),
      decimalPlaces: Number(form.decimalPlaces) || 0,
      isActive: form.isActive,
    });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4 backdrop-blur-sm">
      <div className="w-full max-w-xl overflow-hidden rounded-3xl bg-white shadow-2xl">
        <div className="flex items-center justify-between border-b border-gray-100 px-8 py-6">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              {initialData ? "Edit Unit" : "Add Unit"}
            </h2>
            <p className="mt-1 text-sm text-gray-500">
              Define the unit used for product quantities.
            </p>
          </div>

          <button
            type="button"
            onClick={onClose}
            className="flex h-10 w-10 items-center justify-center rounded-xl bg-gray-100 hover:bg-gray-200"
          >
            <FiX size={18} />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="space-y-6 p-8">
            <div>
              <label className="mb-2 block text-sm font-medium">
                Unit Name *
              </label>
              <input
                value={form.name}
                placeholder="Piece"
                onChange={(event) =>
                  setForm((current) => ({
                    ...current,
                    name: event.target.value,
                  }))
                }
                className="h-12 w-full rounded-xl border border-gray-200 px-4 outline-none focus:border-primary-700 focus:ring-2 focus:ring-primary-100"
                required
              />
            </div>

            <div className="grid gap-6 md:grid-cols-2">
              <div>
                <label className="mb-2 block text-sm font-medium">
                  Unit Code *
                </label>
                <input
                  value={form.code}
                  placeholder="PCS"
                  onChange={(event) =>
                    setForm((current) => ({
                      ...current,
                      code: event.target.value.toUpperCase(),
                    }))
                  }
                  className="h-12 w-full rounded-xl border border-gray-200 px-4 outline-none focus:border-primary-700 focus:ring-2 focus:ring-primary-100"
                  required
                />
              </div>

              <div>
                <label className="mb-2 block text-sm font-medium">
                  Symbol *
                </label>
                <input
                  value={form.symbol}
                  placeholder="pc"
                  onChange={(event) =>
                    setForm((current) => ({
                      ...current,
                      symbol: event.target.value,
                    }))
                  }
                  className="h-12 w-full rounded-xl border border-gray-200 px-4 outline-none focus:border-primary-700 focus:ring-2 focus:ring-primary-100"
                  required
                />
              </div>
            </div>

            <div className="grid gap-6 md:grid-cols-2">
              <div>
                <label className="mb-2 block text-sm font-medium">
                  Decimal Places
                </label>
                <input
                  type="number"
                  min="0"
                  max="6"
                  value={form.decimalPlaces}
                  onChange={(event) =>
                    setForm((current) => ({
                      ...current,
                      decimalPlaces: event.target.value,
                    }))
                  }
                  className="h-12 w-full rounded-xl border border-gray-200 px-4 outline-none focus:border-primary-700 focus:ring-2 focus:ring-primary-100"
                />
              </div>

              <div>
                <label className="mb-2 block text-sm font-medium">
                  Status
                </label>
                <select
                  value={form.isActive ? "active" : "inactive"}
                  onChange={(event) =>
                    setForm((current) => ({
                      ...current,
                      isActive: event.target.value === "active",
                    }))
                  }
                  className="h-12 w-full rounded-xl border border-gray-200 px-4 outline-none focus:border-primary-700 focus:ring-2 focus:ring-primary-100"
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
            </div>
          </div>

          <div className="flex justify-end gap-3 border-t border-gray-100 px-8 py-5">
            <button
              type="button"
              onClick={onClose}
              className="h-11 rounded-xl border border-gray-200 px-6"
            >
              Cancel
            </button>

            <button
              type="submit"
              className="h-11 rounded-xl bg-primary-800 px-6 text-white hover:bg-primary-900"
            >
              {initialData ? "Save Changes" : "Create Unit"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}